import { useState } from "react";
import ToggleButton from "../../ToggleButton";
import  {useCookieHandler} from './hooks/cookie'
import { motion } from "framer-motion";

function ModalUI({ modalHandler, cookiebarHandler }) {
  const [isCookieAccepted,setIsCookieAccepted] = useState(false);
  const [isAnalyticsAllowed,setIsAnalyticsAllowed] = useState(false);
  const {handlePreferences,handleAccept} = useCookieHandler();
   const SaveChanges = ()=>{
    handlePreferences(isCookieAccepted,isAnalyticsAllowed);
    handleAccept();
   }
  return (
            <div className="z-[999999999999999999999999] fixed w-full " 
>

    <div
      className=" h-screen w-screen bg-black/90  flex items-center justify-center absolute cursor-pointer"
      onClick={modalHandler}
    >
       <motion.div
   initial={{ scale: 0.6, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  exit={{ scale: 0.6, opacity: 0 }}   
  transition={{ duration: 0.3, ease: "easeOut" }}
        className="bg-gray-200 w-10/12 md:w-9/12 lg:w-9/12 xl:w-10/12 2xl:w-10/12 rounded-md cursor-default overflow-hidden h-[]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gray-200 px-3 md:px-4 lg:px-14 pt-4 md:pt-14  space-y-10 ">
          <div className="border-b border-gray-400   space-y-2 md:space-y-10">
            <span className="text-[22px] md:text-[28px] font-extrabold ">
              Privacy Overview
            </span>

            <div className="space-y-6 pb-8 h-[60vh] md:h-[40vh] 2xl:h-auto  overflow-y-scroll 2xl:overflow-y-auto custom-scrollbar pr-2">
              <div className="w-full md:w-9/12 md:pr-14 lg:pr-0">
                <p className="text-sm md:text-base">
                  This website uses cookies so that we can provide you with the
                  best user experience possible. Cookie information is stored in
                  your browser and performs functions such as recognising you
                  when you return to our website and helping our team to
                  understand which sections of the website you find most
                  interesting and useful.
                </p>
              </div>
              <div className="space-y-6">
              
                <div className="space-y-4">
                  <div className="space-y-2">
                    <span className="text-base md:text-xl font-bold">
                   Strictly necessary cookies

                    </span>
                  <div className="flex flex-col md:flex-row justify-between space-y-4 md:space-y-2 md:space-x-14 ">
                      <div className="space-y-4">
                        <span className="w-full md:w-9/12">
                          <p className="text-sm md:text-base">
                           Strictly necessary cookies should be enabled at all times so that we can save your preferences for cookie settings.
                          </p>
                        </span>
                        <span className="block">
                          <p className="text-sm md:text-base">
                           If you disable this cookie, we will not be able to save your preferences. This means that every time you visit this website you will need to enable or disable cookies again.
                          </p>
                        </span>
                      </div>
                  
                        <ToggleButton enableValue = {setIsCookieAccepted}/>
                 
                    </div>
                  </div>
                  <div></div>
                </div>
                <div className="space-y-4">
                  <div className="space-y-2">
                    <span className="text-base md:text-xl font-bold">
                      Third-party cookies
                    </span>
                  <div className="flex flex-col md:flex-row justify-between space-y-4 md:space-y-2 md:space-x-14 ">
                      <div className="space-y-4">
                        <span className="w-full md:w-9/12">
                          <p className="text-sm md:text-base">
                            This website uses third party tools such as Google
                            Analytics to collect anonymous information such as
                            the number of visitors to the site, and the most
                            popular pages.
                          </p>
                        </span>
                        <span className="block">
                          <p className="text-sm md:text-base">
                            Keeping this cookie enabled helps us to improve our
                            website.
                          </p>
                        </span>
                      </div>
                     
                        <ToggleButton  enableValue={setIsAnalyticsAllowed}/>
                   
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="py-5 md:py-10 px-3 lg:px-14 flex justify-end">
          <button
            className="bg-[#df73ff] text-xs md:text-sm font-bold inline  px-6 py-3 text-dark transition ease-in duration-300"
onClick={() => {
  SaveChanges();
  // modalHandler();
}}
          >
            Save Changes
          </button>
        </div>
    </motion.div>
      </div>
      </div>
  );
}

export default ModalUI;
